export default "__VITE_ASSET__CpAUoHsG__"